module.exports = __webpack_public_path__ + "static/media/googleLogo.ab6d9dec.svg";